import React, {useEffect, useState} from 'react';

import {Navigate} from 'react-big-calendar';

import SchedulePlaner from "../weekPlaner/SchedulePlaner";
import {fetchWeek, postCourse, postCourseTemp} from "../api/api";
import {getISOWeek} from "date-fns";

export default function WeexWeek({date, localizer, ...props}){
    const [days, setDays] = useState(props.events?.days);
    const [editSeries, setEditSeries] = useState(true);

    async function fetch(type = "temp"){
        return fetchWeek(localizer.startOf(date, 'week').toLocaleDateString('de-DE'), localizer.endOf(date, 'week').toLocaleDateString('de-DE'), type);
    }

    useEffect(() => {
        setDays(null);
        if(editSeries){
            fetch().then((week) => setDays(week.days));
        }
        else{
            fetch("single").then((week) => setDays(week.days));
        }
    }, [date, editSeries]);

    function sendCourseTemp(data){
        const jsonString = JSON.stringify(data, (key, value) => {
            if(key === 'parallels') //has circularises
            {
                return null;
            }
            if(key === 'startDate' || key === 'endDate'){
                //datum mit 00:00 ist wegen timezone +1/2 am tag davor, weil stringify ISO nutzt
                return new Date(value).toLocaleDateString('de-DE');
            }
            else{
                return value;
            }
        });

        if(editSeries){
            return postCourseTemp(localizer.startOf(date, 'week').toLocaleDateString('de-DE'), localizer.endOf(date, 'week').toLocaleDateString('de-DE'), jsonString).then((a) => setDays(a.days));
        }
        else{
            return postCourse(localizer.startOf(date, 'week').toLocaleDateString('de-DE'), localizer.endOf(date, 'week').toLocaleDateString('de-DE'), jsonString).then((a) => setDays(a.days));
        }

    }

    return (<div>
            <SchedulePlaner week0={days} startOfWeek={localizer.startOf(date, 'week')} editSeries={editSeries}
                            setEditSeries={setEditSeries} addCourseTmp={sendCourseTemp}
                            fetchWeek={e => fetch(e).then((week) => setDays(week.days))}
                            preview={props?.preview ?? false}/>
        </div>
    );
}

WeexWeek.navigate = (date, action, {localizer}) => {
    switch(action){
        case Navigate.PREVIOUS:
            return localizer.add(date, -7, 'day');

        case Navigate.NEXT:
            return localizer.add(date, 7, 'day');

        default:
            return date;
    }
};

WeexWeek.title = (date, {localizer}) => {
    return `${localizer.startOf(date, 'week').toLocaleDateString('de-DE')} - ${localizer.endOf(date, 'week').toLocaleDateString('de-DE')} KW ${getISOWeek(date)}`;
};